// ? [REVISIT] Slate's default webpack config doesn't resolve (node-style) folder imports --> workaround
// ? we want to stay organized, but is this right pattern for it ... we'll see
// ? open to feedback on this pattern / potential edge cases
import { renderPdpPage } from './product/index';

renderPdpPage();
import('./product/components/PdpBuilder/lazyInit').then((module) => module.renderPdpBuilder());
